import { FetchError, SDKResponse } from '@commercetools/frontend-sdk';
import { PaginatedOrderHistoryResult } from 'shared/types/cart';
import { WithSDKError } from 'shared/types/shared';

export const getOrders = async (
  customerId: string,
): Promise<SDKResponse<WithSDKError<PaginatedOrderHistoryResult>>> => {
  try {
    const params = new URLSearchParams({
      page: '1',
      page_size: '20',
      ...(customerId && { customer_id: customerId }),
    }).toString();

    const response = await fetch(
      `${
        process.env.NEXT_PUBLIC_EDX_COMMERCE_COORDINATOR_BASE_URL! +
        process.env.NEXT_PUBLIC_EDX_CC_ORDER_HISTORY_PATH!
      }?${params}`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        /**
         * Include cookies with the request.
         *
         * This ensures that session cookies are sent along with the request,
         * even for cross-site requests.
         *
         * For more details, see:
         * - The decision documentation regarding JWT in session cookies
         *   https://github.com/openedx/edx-platform/blob/master/openedx/core/djangoapps/oauth_dispatch/docs/decisions/0009-jwt-in-session-cookie.rst
         * - Mozilla documentation on the `credentials` property
         *   https://developer.mozilla.org/en-US/docs/Web/API/Request/credentials
         */
        credentials: 'include',
      },
    );

    if (response.ok && !response.redirected) {
      const ordersResponse =
        (await response.json()) as PaginatedOrderHistoryResult;

      return {
        data: ordersResponse,
        isError: false,
        tracing: {},
      } as const;
    }

    const errorMessage = await response.text();

    return {
      error: new FetchError(errorMessage),
      isError: true,
      tracing: {},
    };
  } catch (err) {
    return {
      error: { message: (err as Error).message, name: (err as Error).name },
      isError: true,
      tracing: {},
    };
  }
};
